import * as React from 'react';

import classnames from 'classnames';

import {Button} from 'shells/button/button';

import type {Status} from 'nutshell-graphql-types';

import {getCtaButtonText, handleCtaButtonClick} from './helpers';
import type {PageType} from './types';

import styles from './analytics-status.module.css';

type Props = {
    pageType: PageType;
    status: Status;
    onOpenEmbedAnalyticsModal: () => void;
    onClosePopover: () => void;
};

export function PrimaryConfigureCtaButton(props: Props) {
    return (
        <div className={classnames('mt-16', styles['button-container'])}>
            <Button
                variant='primary'
                size='big'
                onClick={() =>
                    handleCtaButtonClick(
                        props.pageType,
                        props.status,
                        props.onOpenEmbedAnalyticsModal,
                        props.onClosePopover
                    )
                }
            >
                {getCtaButtonText(props.pageType, props.status)}
            </Button>
        </div>
    );
}
